<template>
  <div class="wrapper-chart" :class="{'animate__animated animate__bounceInRight': !(isMiniChat || isMainPageChat)}">

    <div class="mobile-nav-block" v-if="!isMiniChat  && router.currentRoute.value.path === LESSON">
      <button @click="cancelTask">
        <img src="img/chart/redo.svg" alt="arrow">
        вернуться
      </button>

      <button @click="openMoreInformationBlock(true)">
        что нужно делать
      </button>
    </div>

    <div class="title-chat">
      <TimerLesson></TimerLesson>

      <div class="wrapper-messages-counter" v-if="!isMiniChat">
        <p>Остаток сообщений:</p>
        <p>
          <span v-if="currentTask?.task?.message_limit">{{ getCountRemainderMessagesInTask() }}</span>
          <span v-else>{{ person?.messages }}</span>
        </p>
      </div>
      <img v-if="isMiniChat" src="img/chart/close.svg" @click="emit('closeMini')" alt="close">
    </div>

    <div class="chat" :class="{'size-mini': isMiniChat}">
      <div class="wrapper-messages" ref="messagesBlock">

        <CharacterBlock v-if="!currentTask?.properties?.length"></CharacterBlock>
        <ShowImagesForTask v-if="currentTask?.properties?.length" :images="currentTask.properties"></ShowImagesForTask>
        <div class="wrapper-message" v-for="message in getCurrentMessages()" :key="message?.id">
          <BotMessage v-if="message.is_bot" :message="message" @openOption="openOptionBlock"></BotMessage>
          <PersonMessage v-else :message="message"></PersonMessage>
        </div>
        <div class="wrapper-message"
             v-if="router.currentRoute.value.path === LESSON ? isActiveGeneration : isActiveGenerationMainChat">
          <div class="typing-message">
            <div class="message animate__animated animate__fast animate__fadeInLeftBig">
              <TypingLoader></TypingLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InputBlock @scrollDown="scrollDown()"></InputBlock>

    <div class="wrapper-loader-for-message" v-if="isActiveLoaderMessageGeneration">
      <LoaderSpiner :is-yellow-color="true"></LoaderSpiner>
      <p class="text">Составляю вам задание<span class="dots"></span></p>
    </div>
  </div>

  <OptionWordBlock ref="optionBlock"
                   :topPosition="top"
                   :leftPosition="left"
                   :word="currentWord?.innerHTML">
  </OptionWordBlock>

  <Transition name="slide-fade">
    <div v-if="isOpenMoreInformationBlock" class="wrapper-mobile-detail-block">
      <TaskAndAnswer
          :isMobileBlock="true"
          @hiddenBlock="openMoreInformationBlock(false)">
      </TaskAndAnswer>
    </div>
  </Transition>
</template>

<script setup>
import {onBeforeUnmount, onMounted, onUnmounted, ref, watch} from "vue";
import {chatStore} from "@/store/chatStore";
import {storeToRefs} from "pinia/dist/pinia";
import dialogsRequests from "@/mixins/requests/dialogsRequests";
import OptionWordBlock from "@/components/chat/OptionWordBlock";
import {onClickOutside} from '@vueuse/core';
import TypingLoader from "@/components/chat/TypingLoader";
import InputBlock from "@/components/chat/InputBlock";
import {useRouter} from "vue-router/dist/vue-router";
import {tasksStore} from "@/store/tasksStore";
import {TASKS, LESSON} from "@/configuration/Routers";
import TaskAndAnswer from "@/components/widgets/TaskAndAnswer";
import PersonMessage from "@//components/chat/PersonMessage";
import LoaderSpiner from "@/components/widgets/LoaderSpiner";
import CharacterBlock from "@/components/chat/CharacterBlock";
import TimerLesson from "@/components/chat/TimerLesson";
import BotMessage from "@/components/chat/BotMessage";
import dictionaryRequests from "@/mixins/requests/dictionaryRequests";
import {mainStore} from "@/store/mainStore";
import taskRequests from "@/mixins/requests/taskRequests";
import ShowImagesForTask from "@/components/chat/ShowImagesForTask";

const router = useRouter();
const emit = defineEmits(['closeMini']);
const prop = defineProps({
  isMiniChat: Boolean,
  isMainPageChat: Boolean
});
const chat = chatStore();
const {changeCurrentPage, triggerScrollDown, clearChatStore} = chat;
const {
  messages,
  mainChatMessages,
  isTriggerScrollDown,
  isActiveGeneration,
  isActiveGenerationMainChat,
  isActiveLoaderMessageGeneration,
  currentPage,
  lastPage,
  triggerSaveScrollForPagination
} = storeToRefs(chat);
const taskStore = tasksStore();
const {changeCurrentTask, changeIsOpenDialog, changeIsOpenRejectDialog} = taskStore;
const {currentTask, userTasks} = storeToRefs(taskStore);
const main = mainStore();
const {person} = storeToRefs(main);
const {
  getMessages,
  getAllMessagesInTask
} = dialogsRequests();
const {getAllUsersWords} = dictionaryRequests();
const {taskShow, getAllUsersTasks} = taskRequests();

let messagesBlock = ref(null);
let top = ref(null);
let left = ref(null);

let currentWord = ref(null);
let optionBlock = ref(null);
let scrollPosition = ref(null);
let isOpenMoreInformationBlock = ref(false);

onMounted(() => {
  if (router.currentRoute.value.query.id && router.currentRoute.value.path === LESSON) {
    if (!userTasks.value) getAllUsersTasks();
    taskShow(router.currentRoute.value.query.id);
    getAllUsersWords();
    getAllMessagesInTask(router.currentRoute.value.query.id);
  } else {
    !mainChatMessages.value.length ? getMessages() : triggerScrollDown();
    if (prop.isMiniChat) document.addEventListener('keyup', handleKeyDown);
  }
  messagesBlock.value.addEventListener('scroll', handelScrollForPagination);
})

onClickOutside(optionBlock, () => {
  closeOptionBlock();
})

watch(isTriggerScrollDown, () => {
  scrollDown();
})

watch(triggerSaveScrollForPagination, () => {
  setTimeout(() => {
    messagesBlock.value.scrollTop = messagesBlock.value.scrollHeight - scrollPosition.value;
    scrollPosition.value = null;
  })
})

function getCurrentMessages() {
  if (router.currentRoute.value.path === LESSON) {
    return messages.value;
  } else {
    return mainChatMessages.value;
  }
}

function handleKeyDown(event) {
  if (event.keyCode === 27) {
    emit('closeMini');
  }
}

function cancelTask() {
  router.push({path: TASKS});
}

function handelScrollForPagination() {
  if (!messagesBlock.value.scrollTop) {
    if (currentPage.value < lastPage.value) {
      changeCurrentPage(currentPage.value + 1);
      getMessages(true);
      scrollPosition.value = event.target.scrollHeight;
    }
  }
}

function openOptionBlock(event) {
  if (!event?.target?.className?.includes('english-word')) return;
  const halfPartWidth = window.innerWidth < 800 ? 150 : 200;
  const leftPos = getCurrentPositionOptionBlock(event, null, halfPartWidth);
  if (!leftPos) return;

  top.value = event.y + event.view.scrollY;
  left.value = leftPos;
  currentWord.value = event.target;
}

function getCurrentPositionOptionBlock(event, positionLeft, halfPartWidth) {
  if (!positionLeft) positionLeft = event.x - halfPartWidth;
  if (isNaN(positionLeft)) return positionLeft;

  if (positionLeft > 20) {
    return positionLeft;
  } else {
    positionLeft = positionLeft + 20;
    return getCurrentPositionOptionBlock(event, positionLeft);
  }
}

function closeOptionBlock() {
  top.value = null;
  left.value = null;
  currentWord.value = null;
}

function openMoreInformationBlock(isOpen) {
  isOpenMoreInformationBlock.value = isOpen;
}

function getCountRemainderMessagesInTask() {
  return currentTask.value?.task?.message_limit - messages.value.filter(message => !message.is_bot).length;
}

function scrollDown() {
  setTimeout(() => {
    messagesBlock.value.scrollTo({
      top: messagesBlock.value.scrollHeight,
      behavior: "smooth"
    });
  }, 0);
}

onBeforeUnmount(() => {
  messagesBlock.value.removeEventListener('scroll', handelScrollForPagination);
})

onUnmounted(() => {
  closeOptionBlock();
  clearChatStore();
  changeCurrentTask(null);
  changeIsOpenDialog(false);
  changeIsOpenRejectDialog(false);
  document.removeEventListener('keyup', handleKeyDown);
})
</script>

<style lang="scss">

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-150vw);
}

.wrapper-mobile-detail-block {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wrapper-chart {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  border-radius: 10px;
  border: 2px solid var(--dark);
  box-shadow: 1px 4px 1px var(--dark);
  background-color: var(--dark-pink);
  color: var(--dark);

  .mobile-nav-block {
    display: none;
    justify-content: space-between;
    padding: 10px;

    button {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 5px 10px;
      border-radius: 10px;
      background-color: var(--pink);
      border: 2px solid var(--dark);
      box-shadow: 1px 4px 1px var(--dark);
      transition: all 0.2s;
      cursor: pointer;
      color: var(--white);

      &:active {
        box-shadow: 0 0 1px var(--dark);
        transform: translateY(5px);
      }

      &:hover {
        background-color: var(--dark-pink);
      }

      img {
        width: 20px;
        height: 20px;
        transform: rotateY(180deg);
      }
    }
  }

  .title-chat {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    color: var(--light-gray);

    h3 {
      font-weight: 900;
    }

    img {
      width: 30px;
      height: 30px;
      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        transform: scale(1.2);
      }
    }

    .wrapper-messages-counter {
      display: flex;
      gap: 10px;

      p {
        font-weight: 800;
        font-size: 18px;
      }
    }
  }

  .chat {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1;
    width: 100%;
    border-top: 1px solid var(--dark-pink);
    border-bottom: 1px solid var(--dark-pink);
    background-color: var(--pink);
    overflow: hidden;

    .wrapper-messages {
      overflow-x: hidden;
      overflow-y: auto;
      scrollbar-gutter: stable;
      padding: 5px 10px 0 10px;

      .wrapper-message {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 10px;

        .typing-message {
          display: flex;
        }

        :deep(.animate__fast) {
          --animate-duration: 0.3s;
        }

        .sound-message {
          padding: 5px 10px 0 10px;
        }

        .error-message,
        .done-message {
          margin-top: 3px;
          color: red;
          font-size: 12px;
        }

        .done-message {
          color: #67f967;
        }

        :deep(.player) {
          #duration,
          #current-time {
            opacity: 0;
            margin: 0;
            min-width: 0;
            width: 0;
          }

          #play {
            padding: 0;

            svg {
              fill: var(--green);
            }
          }

          #slider {
            svg {
              #path1 {
                stroke: #232323;
              }

              #path2 {
                stroke: #00c6ad;
              }
            }
          }

          #seek-slider::-webkit-slider-thumb {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            -webkit-appearance: none;
            cursor: ew-resize;
            background: var(--green);
          }
        }
      }
    }
  }

  .size-mini {
    .wrapper-messages {
      padding: 5px 2px 0 2px;

      .wrapper-message {
        .message {
          max-width: 75%;
        }

        :deep(.player) {
          #slider {
            svg {
              width: 150px;
            }
          }
        }
      }
    }
  }

  .wrapper-loader-for-message {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    background-color: rgba(163, 54, 214, 0.6);

    .text {
      display: flex;
      align-items: flex-end;
      color: var(--yellow);
      font-size: 18px;

      .dots {
        display: flex;
        width: 5px;
        margin-left: 14px;
        margin-bottom: 7px;
        aspect-ratio: 1;
        border-radius: 50%;
        animation: l5 2s infinite linear alternate;
      }

      @keyframes l5 {
        0% {
          box-shadow: 8px 0 #ffd073, -8px 0 #0002;
          background: #ffd073
        }
        33% {
          box-shadow: 8px 0 #0002, -8px 0 #ffd073;
          background: #0002
        }
        66% {
          box-shadow: 8px 0 #ffd073, -8px 0 #0002;
          background: #0002
        }
        100% {
          box-shadow: 8px 0 #0002, -8px 0 #ffd073;
          background: #ffd073
        }
      }
    }
  }
}

.tooltip-lesson.v-tooltip > .v-overlay__content {
  display: flex;
  background-color: var(--yellow) !important;
  opacity: 0.9;
  color: var(--blue) !important;
  border-radius: 10px;
  border: 1px solid var(--dark);
}

@media screen and (min-width: 2200px) {
  .wrapper-chart {
    .title-chat {
      h3 {
      }

      .wrapper-messages-counter {
        p {
          font-size: 23px;
        }
      }
    }
  }
}

@media screen and (max-width: 1100px) {
  .wrapper-chart {
    .title-chat {
      padding: 10px;

      h3 {
        font-size: 15px;
      }

      .wrapper-messages-counter {
        align-items: center;

        p {
          font-size: 13px;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .wrapper-chart {
    border-radius: unset;
    border: unset;

    .mobile-nav-block {
      display: flex;
    }
  }
}

@media screen and (max-width: 400px) {
  .wrapper-chart {
    .mobile-nav-block {
      button {
        font-size: 12px;
      }
    }

    .title-chat {
      gap: 0;
      padding: 0 10px 5px;

      h3 {
        font-size: 13px;
      }

      .wrapper-messages-counter {
        p {
          display: flex;
          align-items: center;
          font-size: 12px;
        }
      }
    }

    .chat {
      .wrapper-messages {
        padding: 5px 5px 0 5px;
      }
    }
  }
}
</style>
